'use strict';

(function () {
  'use strict';

  angular.module('msActivities').filter('showSectionHistory', showSectionHistory);

  function showSectionHistory() {
    return showSectionHistoryFilter;

    ////////////////

    function showSectionHistoryFilter(sections) {
      return sections.filter(filter);
    }

    function filter(section) {
      return section.allowHistoryView || section.widgets.filter(function (w) {
        return w.response;
      }).length > 0;
    }
  }
})();